import { object, string } from 'yup';
import { IChangePasswordFormData } from '../../../model/IChangePasswordFormData';
import { ITranslationFunction } from '../../../../../shared/i18n/translate';
import { createSignUpSchema } from '../../../../sign-up/domain/models/SignUpSchema';

export function createChangePasswordSchema(t: ITranslationFunction) {
	const signUpSchema = createSignUpSchema(t);

	return object<IChangePasswordFormData>({
		currentPassword: string()
			.required(t('password_form_field_error'))
			.min(8, t('user_form_password_min_length_error')),
		password: signUpSchema.fields.password,
		confirmPassword: signUpSchema.fields.confirmPassword,
	}).required();
}
